<template>
    <md-menu md-direction="bottom-end" md-align-trigger>
        <md-button class="md-just-icon md-primary" md-menu-trigger>
            <md-icon> more_horiz</md-icon>
        </md-button>

        <md-menu-content>
            <li>
                <a @click="actionEdit">Edit</a>
            </li>
        </md-menu-content>
    </md-menu>
</template>

<script>
    export default {
        name: "ResellerMoreDropdown",
        props: {
            reseller: {
                type: Object,
                required: true,
            }
        }, computed: {

        }, methods: {
            actionEdit() {
                let path = this.$enums.RoutePathEnum.RESELLER_UPDATE;
                path = path.replace(':id', this.reseller.id);

                this.$router.push(path);
            },
        }
    }
</script>
